// extracted by mini-css-extract-plugin
export var header = "dg_kc";
export var header__logo = "dg_lc";
export var link = "dg_mc";